import { Component, OnInit, Output, EventEmitter } from '@angular/core';
import {switchMap, debounceTime, tap, finalize, map, startWith} from 'rxjs/operators';
import { SaleService } from '../../../services/sale.service';
import { FormControl } from '@angular/forms';
import {FormBuilder, FormGroup} from '@angular/forms';

export interface List {
  id: number;
  name: string;
}

@Component({
  selector: 'app-filter-so',
  templateUrl: './filter-so.component.html',
  styleUrls: ['./filter-so.component.css']
})
export class FilterSoComponent implements OnInit {

  public loading = false;
  public myControl = new FormControl();
  soForm: FormGroup;
  @Output() select: EventEmitter<any>;
  public filteredSOs: any;
  public x: any;
  options: List[] = [];

  constructor(
    private _saleService: SaleService,
    private fb: FormBuilder,
  ) {
    this.select = new EventEmitter;
  }

  ngOnInit() {
    this.soForm = this.fb.group({
      userInput: null
    });

      this.soForm
      .get('userInput')
      .valueChanges
      .pipe(
        debounceTime(300),
        tap(() => this.loading = true),
        switchMap(value => this._saleService.searchSO(value)
        .pipe(
          finalize(() => this.loading = false),
          )
        )
      )
      .subscribe(response => {
        this.x = response;
        console.log(this.x.data);
        let element;
        this.options = [];
        for (element of this.x.data) {
          this.options.push(
            {
              id: element.id,
              name: element.so,
            }
          );
        }
        this.filteredSOs = this.myControl.valueChanges.pipe(
          startWith<string | List>(''),
          map(value => typeof value === 'string' ? value : value.name),
          map(name => name ? this._filter(name) : this.options.slice())
        );
      });
  }

  private _filter(name: string): List[] {
    const filterValue = name.toLowerCase();
    return this.options.filter(option => option.name.toLowerCase().includes(filterValue));
  }

  displayFn(user?: List): string | undefined {
    return user ? user.name : undefined;
  }

  OnHumanSelected(option) {
    // console.log(option);
    this.select.emit(option.value);
   }

}
